import Axios from "axios";
import { ServiceApi } from "./Api";

export class ServiceConfig {
    async GetConfig() {
        var servico = await ServiceApi._getUrl();
        return await ServiceApi.get(servico+'Api/Config/GetConfig');
    } 
}